export class ModalOrNotificationList
{
	static init()
	{
		const Ticketing = window.Ticketing || (window.Ticketing = {});
		if (Ticketing.modalOrNotificationListInitialized === undefined) {
			window.addEventListener('resize', ModalOrNotificationList.#recalculateVh);
			window.addEventListener('orientationchange', ModalOrNotificationList.#recalculateVh);
			Ticketing.modalOrNotificationListInitialized = true;
		}
	}

	static #recalculateVh()
	{
		if (ModalOrNotificationList.isAnyOpen()) {
			document.documentElement.style.setProperty('--vh-set', `${window.innerHeight / 100}px`);
		}
	}

	static isAnyOpen()
	{
		const modalOpen = document.querySelectorAll('.o-body--withOpenModal').length === 1;
		const notificationListOpen = document.querySelectorAll('.o-body--withOpenNotifications').length === 1;
		
		return modalOpen || notificationListOpen;
	}

	/**
	* To be used before body class application
	*/
	static open()
	{
		if (ModalOrNotificationList.isAnyOpen()) {
			ModalOrNotificationList.#recalculateVh();
			const body = document.querySelectorAll('.o-body')[0];
			body.dataset.windowScrollTop = window.scrollY;
			const scrollYWidth = window.innerWidth - document.documentElement.clientWidth;
			document.documentElement.style.setProperty('--scroll-y-position', `-${body.dataset.windowScrollTop}px`);
			document.documentElement.style.setProperty('--scroll-y-width', `${scrollYWidth}px`);	
		}
	}

	/**
	* To be used after body class application
	*/
	static close()
	{
		if (!ModalOrNotificationList.isAnyOpen()) {
			const body = document.querySelectorAll('.o-body')[0];
			window.scroll(0, body.dataset.windowScrollTop);
			body.removeAttribute('data-window-scroll-top');
			document.documentElement.style.setProperty('--scroll-y-position', 0);
			document.documentElement.style.setProperty('--scroll-y-width', 0);
			document.documentElement.style.setProperty('--vh-set', '1vh');
		}
	}
}
